import { useTranslation } from 'react-i18next';
import { Row, Text } from 'ui';

type P = {
  updatedAt: number[];
};

const TodosWidgetUpdatedAt = ({ updatedAt }: P) => {
  const { t } = useTranslation();

  return (
    <Row className="todos-widget-updated-at" justify="center">
      <Text type="secondary">
        {t(`Last updated on`, {
          lastUpdateTime: new Date(Math.min(...updatedAt)),
        })}
      </Text>
    </Row>
  );
};

export default TodosWidgetUpdatedAt;
